module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "600px",
      "lazy": ""
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("View and edit tags for this track")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": "",
      "lg6": ""
    }
  }, [_c('v-subheader', [_vm._v("Tagged by others")]), _vm._v(" "), (_vm.audioTags.length) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.audioTags), function(tag, index) {
    return [_c('v-list-tile', {
      key: tag.id + 100000
    }, [_c('v-list-tile-content', [_vm._v("\n                                        " + _vm._s(tag.name) + "\n                                    ")]), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n                                        " + _vm._s(tag.user_count) + "\n                                    ")])], 1), _vm._v(" "), _c('v-divider', {
      key: index
    })]
  })], 2) : _c('div', [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Nothing here yet")])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": "",
      "lg6": ""
    }
  }, [_vm._v("\n\n                        Tags should be in "), _c('strong', [_vm._v("English")]), _vm._v(".\n                        "), _c('br'), _vm._v("\n                        Use terms that you think other users would find useful to browse by.\n\n                        "), _c('input-audio-tags', {
    model: {
      value: (_vm.form.tags),
      callback: function($$v) {
        _vm.$set(_vm.form, "tags", $$v)
      },
      expression: "form.tags"
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "grey--text"
  }, [_vm._v("Apply a tag that you've already applied to other tracks:")]), _vm._v(" "), (_vm.userDistinctTags.length) ? _vm._l((_vm.userDistinctTags), function(tag) {
    return _c('v-chip', {
      key: tag.id,
      staticClass: "hover-show-hidden",
      attrs: {
        "small": ""
      }
    }, [_vm._v("\n                                    " + _vm._s(tag.name) + "\n                                    "), _c('v-icon', {
      staticClass: "hidden no-transition",
      attrs: {
        "right": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addTag(tag)
        }
      }
    }, [_vm._v("add_circle\n                                    ")])], 1)
  }) : _vm._e()], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d6442eb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DialogAddTag.vue
// module id = 388
// module chunks = 0